module.exports = __webpack_public_path__ + "static/media/download.f9441a39.svg";